import { DefaultButton, DialogFooter, Modal, PrimaryButton } from '@fluentui/react';
import { FCWithChildren, createContext, useState } from 'react';
import { ModalHeader } from '../shared/styled-components';

interface DialogProps {
  title: string;
  content: string | JSX.Element;
  onAccept(): void;
  width?: string | number;
  acceptText?: string;
  declineText?: string;
}

const defaultDialogProps: DialogProps = {
  title: '',
  content: '',
  onAccept: () => { /* do nothing */ },
};

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DialogContext = createContext<{ openDialog(props: DialogProps): void }>(undefined!);

const Dialogs: FCWithChildren = ({ children }) => {
  const [dialogProps, setDialogProps] = useState<DialogProps>(defaultDialogProps);
  const [isOpen, setIsOpen] = useState(false);

  const decline = () => {
    setIsOpen(false);
  };

  const accept = () => {
    dialogProps.onAccept();
    setIsOpen(false);
  };

  const openDialog = (props: DialogProps) => {
    setDialogProps(props);
    setIsOpen(true);
  };

  return (
    <DialogContext.Provider value={{ openDialog }}>
      {children}
      <Modal isOpen={isOpen} styles={{ main: { width: dialogProps.width ?? 300, height: 190 } }}>
        <ModalHeader title={dialogProps.title} />
        <div style={{ flexGrow: 1, whiteSpace: 'pre-wrap' }}>
          {dialogProps.content}
        </div>
        <DialogFooter>
          <PrimaryButton onClick={accept} text={dialogProps.acceptText ?? 'Yes'} />
          <DefaultButton onClick={decline} text={dialogProps.declineText ?? 'Cancel'} />
        </DialogFooter>
      </Modal>
    </DialogContext.Provider>
  );
};

export default Dialogs;